exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-header[data-v-246e784b] {\r\n  border-bottom: 1px solid #E6EAEE;\n}\n.my-main[data-v-246e784b] {\r\n  position: relative;\r\n  height: 100vh;\n}\r\n", ""]);

// exports
